export default "__VITE_ASSET__DhS1pgcA__"